var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 27,
  viewBox: "0 0 24 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.46938 26.1635C1.40431 26.1635 0.543823 25.3436 0.543823 24.3288C0.543823 23.314 1.40431 22.4941 2.46938 22.4941H21.7249C22.79 22.4941 23.6505 23.314 23.6505 24.3288C23.6505 25.3436 22.79 26.1635 21.7249 26.1635H2.46938ZM13.4571 18.2858C12.7049 19.0024 11.4834 19.0024 10.7312 18.2858L3.02899 10.947C2.27682 10.2303 2.27682 9.06638 3.02899 8.3497C3.78116 7.63302 5.00269 7.63302 5.75485 8.3497L10.1716 12.558V2.31239C10.1716 1.29757 11.0321 0.477692 12.0971 0.477692C13.1622 0.477692 14.0227 1.29757 14.0227 2.31239V12.558L18.4394 8.3497C19.1916 7.63302 20.4131 7.63302 21.1653 8.3497C21.9175 9.06638 21.9175 10.2303 21.1653 10.947L13.4631 18.2858H13.4571Z",
  fill: "#252525"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.7656069d3352ed0f5e5290a6ef88c084.svg";